<script setup lang="ts">
  /**
   * RadioGroup 单选框组组件
   * @description
   * 1. 用于在一组选项中进行单选
   * 2. 基于 reka-ui 的 RadioGroupRoot 构建
   * 3. 提供无障碍访问支持
   */
  import type { RadioGroupRootEmits, RadioGroupRootProps } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { RadioGroupRoot, useForwardPropsEmits } from 'reka-ui'
  import { cn } from '@rapoo/element/lib/utils'

  const props = defineProps<RadioGroupRootProps & { class?: HTMLAttributes['class'] }>()
  const emits = defineEmits<RadioGroupRootEmits>()

  const delegatedProps = reactiveOmit(props, 'class')

  const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <RadioGroupRoot :class="cn('grid gap-2', props.class)" v-bind="forwarded">
    <slot />
  </RadioGroupRoot>
</template>
